import { z } from "zod"

const schema = z.object({
  contractVersion: z.literal(1),
  scopeKey: z.string().regex(/^[a-f0-9]{64}$/i),
  role: z.enum(["admin", "data_staff", "intake_staff", "proofer", "guest"]),
  permissions: z.array(z.string().min(1).max(128)).max(1024),
  features: z.object({ amsBooking: z.boolean() }),
})
export type StaffAccessContext = z.infer<typeof schema>
export class StaffAccessDeniedError extends Error {
  constructor() { super("Staff access was revoked."); this.name = "StaffAccessDeniedError" }
}

export function decodeStaffAccessContext(value: unknown): StaffAccessContext {
  const result = schema.safeParse(value)
  if (!result.success) throw new Error("Staff access context is unavailable.")
  return result.data
}
